export default __webpack_public_path__ + "error.827ed8ecee534da9af9f4f12e2e0c01e.svg";